import {Controller} from "@hotwired/stimulus"

export class AlarmOrderRadioSelect extends Controller {
	static targets = ["radio", "select"]

	connect() {
		this.reconnect = this.reconnect.bind(this); // Ensure that `this` points back to our controller
		window.addEventListener('turbo:morph', this.reconnect);
		this.initSelect()
	}

	initSelect() {
		this.selectTarget.value    = this.radioTarget.value
		this.selectTarget.disabled = !this.radioTarget.checked

		const queryName  = CSS.escape(this.radioTarget.name)
		this.boundChange = this.change.bind(this)
		this.radios      = document.querySelectorAll(`input[name=${queryName}]`)
		this.radios.forEach((el) => el.addEventListener("change", this.boundChange))
	}

	destroySelect() {
		this.radios?.forEach((el) => el.removeEventListener("change", this.boundChange))
	}

	disconnect() {
		window.removeEventListener('turbo:morph', this.reconnect);
		this.destroySelect()
	}

	change() {
		this.selectTarget.disabled = !this.radioTarget.checked
	}

	update() {
		this.radioTarget.value   = this.selectTarget.value
		this.radioTarget.checked = true
	}

	reconnect() {
		this.destroySelect()
		this.initSelect()
	}
}
